export default "__VITE_ASSET__nbH2t_2j__"